const profilerProcessTypes = {
    CONNECT_AND_SYNC: 'CONNECT_AND_SYNC',
    CONNECT_AND_SYNC_HOLDER: 'CONNECT_AND_SYNC_HOLDER',
};

export default profilerProcessTypes;
